import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/views/Home.vue";
import NotFound from "@/views/NotFound.vue";
import Courses from "@/views/course/Courses.vue";
import CourseDetail from "@/views/course/CourseDetail.vue";
import BundleCourseDetail from "@/views/bundle-course/BundleCourseDetail.vue";
import MyCourses from "@/views/my-course/MyCourses.vue";
import MyCourseDetail from "@/views/my-course/MyCourseDetail.vue";
import Checkout from "@/views/payment/Checkout.vue";
import Payment from "@/views/payment/Payment.vue";
import Register from "@/views/auth/Register.vue";
import PasswordRequest from "@/views/auth/PasswordRequest.vue";
import PasswordReset from "@/views/auth/PasswordReset.vue";
import Login from "@/views/auth/Login.vue";
import Profile from "@/views/Profile.vue";
import ComingSoon from "@/views/ComingSoon.vue";
import GuestPayment from "@/views/payment/GuestPayment.vue";
import TermAndCondition from "@/views/TermAndCondition.vue";
import VerifyEmail from "@/views/auth/VerifyEmail.vue";
import InstructorDetail from "@/views/course/InstructorDetail.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/term-and-condition",
    name: "term-and-condition",
    component: TermAndCondition,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  // {
  //   path: "/password/request",
  //   name: "password-request",
  //   component: PasswordRequest,
  // },
  // {
  //   path: "/password/reset/:token",
  //   name: "password-reset",
  //   component: PasswordReset,
  // },
  {
    path: "/verify-email",
    name: "verify-email",
    component: VerifyEmail,
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
  },
  {
    path: "/courses",
    name: "courses",
    component: Courses,
  },
  {
    path: "/course/:slug",
    name: "course-detail",
    component: CourseDetail,
  },
  {
    path: "/instructor/:id",
    name: "instructor-detail",
    component: InstructorDetail,
  },
  {
    path: "/bundle/:slug",
    name: "bundle-course-detail",
    component: BundleCourseDetail,
  },
  {
    path: "/my-courses",
    name: "my-courses",
    component: MyCourses,
  },
  {
    path: "/my-course/:slug",
    name: "my-course-detail",
    component: MyCourseDetail,
  },
  {
    path: "/checkout:token",
    name: "checkout",
    component: Checkout,
  },
  {
    path: "/checkout/:invoice",
    name: "payment",
    component: Payment,
  },
  {
    path: "/guest/payment/:status",
    name: "guest-payment",
    component: GuestPayment,
  },
  {
    path: "/coming-soon",
    name: "coming-soon",
    component: ComingSoon,
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => {
    return {
      x: 0,
      y: 0,
    };
  },
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.name !== "home") {
//     next({ name: "home" });
//   }
//   next();
// });

export default router;
